import { render, staticRenderFns } from "./MailROITable.vue?vue&type=template&id=39101cc2&scoped=true&"
import script from "./MailROITable.vue?vue&type=script&lang=js&"
export * from "./MailROITable.vue?vue&type=script&lang=js&"
import style0 from "./MailROITable.vue?vue&type=style&index=0&id=39101cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39101cc2",
  null
  
)

export default component.exports